import React from "react"
import { StyledFlexContainer } from "./styled"

const FlexContainer = (props) => <StyledFlexContainer {...props} />

export default FlexContainer
